<template>
  <div class="home_page">
    <el-breadcrumb separator="/" style="line-height: 40px">
      <el-breadcrumb-item :to="{ name: 'basicInfo' }">个人中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'orderList' }">我的订单</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="order_evaluate">
      <h2>订单评价</h2>
      <div>订单编号：{{orderDetail ? orderDetail.orderCode : ''}}</div>
      <div class="List" v-if="orderDetail">
        <div v-for="(item, index) in orderDetail.itemList"
              :class="index === 0? 'One_':'One'"
              :key="index">
          <div class="Mess">
            <div class="img">
              <img :src="item.goodsUrl">
            </div>
            <div class="message">
              <div class="message_title">
                <div class="message_title_one">编号：</div>
                <div class="message_title_one">品牌：</div>
                <div class="message_title_one">型号：</div>
              </div>
              <div class="message_answer">
                <div class="message_title_one">{{item.goodsCode}}</div>
                <div class="message_title_one">{{item.brandName}}</div>
                <div class="message_title_one">{{item.goodsModel}}</div>
              </div>
            </div>
          </div>
          <div class="Eval">
            <div class="eval_name">
              <div><span style="color:#666666;">商品名称</span></div>
              <div>
                <span style="color:#666666;margin-left:40px">{{item.goodsName}}</span>
              </div>
            </div>
            <div class="eval_rate">
              <div><span style="color:#666666;">星级评价</span></div>
              <div>
                <el-rate :value="item.goodsEvaluateScore/2"
                          style="margin-left:40px" allow-half disabled></el-rate>
              </div>
            </div>
            <div class="eval_mess">
              <div><span style="color:#666666">评价内容</span></div>
              <div style="margin-left:40px">
                <textarea style="resize: none;"
                          cols="58"
                          rows="4"
                          disabled
                          :maxlength="200"
                          v-model="item.goodsEvaluateContent"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="order_evaluate">
      <div class="overall_evaluation">
        <div class="upload">
          <div class="upload_mess">晒图上传（最多上传8张图片）</div>
          <el-upload style="margin-top:20px"
                     width="80px"
                     ref="upload"
                     action="actionUrl"
                     list-type="picture-card"
                     disabled
                     :file-list="fileList"
                     :on-preview="handlePictureCardPreview">
            <!-- <i class="el-icon-plus"></i> -->
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%"
                 :src="dialogImageUrl"
                 alt="">
          </el-dialog>
        </div>
        <div class="overall_eval">
          <div style=" color: #666666;font-size:14px;">商家态度评价</div>
          <div class="eval_one">物流效率评价</div>
          <div class="eval_one">整体评价</div>
          <div class="eval_one">评价内容</div>
        </div>
        <div class="overall_eval">
          <el-rate :value="orderDetail ? orderDetail.marchantAttituideScore/2 : 0" allow-half
                   disabled
                   style="margin-left:44px"></el-rate>
          <el-rate class="eval_one" allow-half
                   :value="orderDetail?orderDetail.logisticsEfficiencyScore/2:0"
                   disabled
                   style="margin-left:44px"></el-rate>
          <el-rate class="eval_one" allow-half
                   :value="orderDetail?orderDetail.allScore/2:0"
                   disabled
                   style="margin-left:44px"></el-rate>
          <textarea class="eval_one"
                    style="margin-left:15px;resize: none;"
                    cols="58"
                    :maxlength="200"
                    disabled
                    rows="4"
                    v-model="orderDetail.evaluateContent"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Cookies from 'js-cookie'
export default {
  data () {
    return {
    //   loading: false,
      orderDetail: null,
      fileList: [],
      // 预览图片
      dialogVisible: false,
      dialogImageUrl: ''
    }
  },
  computed: {
    orderId () {
      return this.$route.query.id
    }
  },
  mounted () {
    this.getOrderDetail()
  },
  methods: {
    // 获取订单评价详情
    getOrderDetail () {
      if (!this.orderId) {
        return false
      }
      this.$request.get(`/front/consumer/order/evaluate/info/${this.orderId}`)
        .then((res) => {
          this.orderDetail = res
          if (res.evaluatePicUrlList && res.evaluatePicUrlList.length) {
            this.fileList = res.evaluatePicUrlList.map(item => {
              return {
                url: item,
                name: 'q',
                success: 0
              }
            })
          }
        })
        .catch(() => {
          this.orderDetail = null
        })
    },
    // 删除图片
    handleRemove (file, fileList) {
      if (file.response && file.response.data) {
        this.deleteIds.push(file.response.data.aliOssId)
      }
    },
    // 图片超出数量提示
    handleExceed () {
      this.$message.error('最多上传8张图片')
    },
    // 预览图片
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 校验图片格式
    beforeUpload (file) {
      let type = file.name.substring(file.name.lastIndexOf('.'))
      const isLt2M = file.size / 1024 / 1024 < 8
      var reg = /\.(jpg|bmp|gif|jpeg|png)$/
      const isJPG = reg.test(type)
      if (!isJPG) {
        this.$message.error('上传文件只能是 jpg|bmp|gif|jpeg|png 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 8MB!')
      }
      return isJPG && isLt2M
    },
    handleSuccess (res) {
      if (res.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        // this.dataForm.contractUrl = res.data.url
        // this.IdcardBackUrl = res.data.url
        // this.IdcardBackId = res.data.aliOssId
      } else {
        // this.dataForm.contractUrl = ''
        this.$message({
          message: res.message,
          type: 'error'
        })
      }
    },
    // 提交评价
    submitRate () {
      if (this.loading) {
        return false
      }
      let evaluatePicUrl = this.$refs.upload.uploadFiles.map(item => {
        return item.response.data.url
      }).join()
      // 商品评价
      let evaluateItemFormList = []
      this.goodList.forEach((item, index) => {
        evaluateItemFormList.push({
          payOrderItemId: item.orderItemId,
          goodsEvaluateScore: this.Score[index] * 2,
          goodsEvaluateContent: this.Mess[index]
        })
      })
      this.loading = true
      this.$http.post(`/front/consumer/order/evaluate/saveOrderEvaluate`, {
        orderId: this.orderId,
        marchantAttituideScore: this.marchantAttituideScore * 2,
        logisticsEfficiencyScore: this.logisticsEfficiencyScore * 2,
        allScore: this.allScore * 2,
        evaluateContent: this.evaluateContent,
        evaluatePicUrl: evaluatePicUrl,
        evaluateItemFormList: evaluateItemFormList
      })
        .then(({ data: res }) => {
          this.loading = false
          if (res.code === 0) {
            this.$router.go(-1)
          }
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang='scss' scoped>
.order_evaluate{
  margin-top: 10px;
  background: #fff;
  padding: 30px 142px;
  .List {
    width: 905px;
    margin-top: 20px;
    font-size: 14px;
    color: #333333;
    .One {
      display: flex;
      border-right: 1px solid #d3d3d3;
      border-left: 1px solid #d3d3d3;
      border-bottom: 1px solid #d3d3d3;
    }
    .One_ {
      display: flex;
      border: 1px solid #d3d3d3;
    }
    .Mess {
      width: 280px;
      min-height: 250px;
      text-align: center;
      border-right: 1px solid #d3d3d3;
      .img {
        margin-top: 10px;
      }
      img {
        width: 74px;
        height: 113px;
      }
      .message {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        margin-left: 15px;
        margin-top: 10px;
        color: #333333;
        font-size: 14px;
      }
      .message_title {
        text-align: right;
      }
      .message_answer {
        text-align: left;
      }
      .message_title_one {
        margin-top: 10px;
      }
    }
    .Eval {
      display: flex;
      flex-direction: column;
      margin-left: 32px;
      .eval_name {
        display: flex;
        margin-top: 30px;
      }
      .eval_rate {
        display: flex;
        margin-top: 30px;
      }
      .eval_mess {
        display: flex;
        flex-direction: row;
        margin-top: 30px;
      }
    }
  }
  .overall_evaluation{
    display: flex;
    flex-direction: row;
    .upload {
      width: 292px;
      .upload_mess {
        font-size: 14px;
        color: #666666;
        margin-top: 43px;
      }
    }
    .overall_eval{
      margin-top: 43px;
      .eval_one {
        margin-top: 33px;
        color: #666666;
        font-size: 14px;
      }
    }
  }
  .botm_btn {
    margin-top: 38px;
    text-align: center;
    .btn {
      width: 320px;
      height: 50px;
      background-color: #1d65a8;
      font-size: 16px;
      color: #fff;
    }
  }
  /deep/.el-upload--picture-card {
    display: none;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 80px;
    height: 80px;
    line-height: 88px;
    vertical-align: top;
  }
  /deep/.el-upload-list__item{
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 80px;
    height: 80px;
    line-height: 88px;
    vertical-align: top;
  }
}
</style>
